<template>
  <div v-if="model.showLogin" class="login-mask" :style="`width:${model.clientWidth}px;height:${model.clientHeight}px`">
    <div class="login-bar">
      <div class="img-bar">
        <div class="img-title">
          <img class="it-icon" :src="require('@/assets/home/header-icon.png')" />
          <div class="it-label">AI云量化</div>
        </div>
        <img class="img-image" :src="require('@/assets/login/login-icon.png')" />
      </div>
      <div class="form-bar">
        <div class="form-tab">
          <div :class="`tab-item ${model.activeTab==='smsLogin'?'tab-active':''}`" @click="handleClickTab('smsLogin')">短信登录</div>
          <div :class="`tab-item ${model.activeTab==='userLogin'?'tab-active':''}`" @click="handleClickTab('userLogin')">账号登录</div>
        </div>
        <SmsLogin v-if="model.activeTab==='smsLogin'" />
        <UserLogin v-if="model.activeTab==='userLogin'" />
        <div style="text-align: center;margin-top: 50px;"><a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2023006359号-1</a></div>
      </div>
    </div>
  </div>
</template>
      
<script setup>
import { onBeforeMount, onMounted, reactive, getCurrentInstance } from "vue";
import SmsLogin from "./sms-login.vue";
import UserLogin from "./user-login.vue";

const storageLabel = getCurrentInstance().appContext.config.globalProperties.storageLabel;

const model = reactive({
  showLogin: false,
  clientHeight: 0,
  clientWidth: 0,
  activeTab: "smsLogin",
});
//窗体变化
onBeforeMount(() => {
  // localStorage.removeItem(storageLabel() );
  model.showLogin = localStorage.getItem(storageLabel() ) === null;
  model.clientHeight = document.documentElement.clientHeight;
  model.clientWidth = document.documentElement.clientWidth;
});

//监听窗体变化
onMounted(() => {
  window.onresize = () => {
    return (() => {
      model.clientHeight = document.documentElement.clientHeight;
      model.clientWidth = document.documentElement.clientWidth;
    })();
  };
  if (model.showLogin) {
    document.addEventListener("mousewheel", disableMousewheel, { passive: false });
  }
});
//禁用滚轮
function disableMousewheel(e) {
  e.preventDefault();
}
// function clearMouseWhell() {
//   document.removeEventListener("mousewheel", this.mousewheelHandler, { passive: false });
// }

//菜单切换
function handleClickTab(tab) {
  model.activeTab = tab;
}
</script>
<style lang="scss" scoped>
.login-mask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: #0000005a;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 820px;
  min-height: 520px;
}
.login-bar {
  width: 820px;
  height: 520px;
  background: #fff;
  display: flex;
  border-radius: 8px;
  .img-bar {
    width: 50%;
    background: rgba(51, 149, 255, 0.6);
    border-radius: 8px 0px 0px 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 40px;
    box-sizing: border-box;
    .img-title {
      display: flex;
      align-items: center;
      justify-content: center;
      .it-icon {
        width: 48px;
        height: 48px;
        margin-right: 17px;
      }
      .it-label {
        font-size: 24px;
        font-weight: 600;
      }
    }
    .img-image {
      width: 100%;
    }
  }
  .form-bar {
    width: 50%;
    box-sizing: border-box;
    padding: 72px 48px;
  }
  .form-tab {
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
    .tab-item {
      width: 72px;
      height: 26px;
      font-weight: 500;
      font-size: 18px;
      cursor: pointer;
      &:nth-child(odd) {
        margin-right: 48px;
      }
    }
    .tab-active {
      border-bottom: 2px solid #3395ff;
    }
  }
}
</style>
      